<section class="content">
  <span class="info">
    {{ 'common.alarm-rule.action.create-alarm.info' | translateSafe }}
  </span>
</section>